export default "__VITE_ASSET__DrCxMYtW__"